import { render, staticRenderFns } from "./ForgingStats.vue?vue&type=template&id=e4bc8c02&"
import script from "./ForgingStats.vue?vue&type=script&lang=ts&"
export * from "./ForgingStats.vue?vue&type=script&lang=ts&"
import style0 from "./ForgingStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports